import { useAuth } from "../authContext"

const NavOrFootByAdmin = ({ children }) => {
  const { currentUser } = useAuth()

  const isNonAdmin = !currentUser || currentUser.photoURL !== "admin"

  return isNonAdmin ? children : null
}

export default NavOrFootByAdmin
